import { useHistoryStack } from '@work4all/components/lib/navigation/history-stack';

export function StackContent() {
  const { current } = useHistoryStack();
  return <div>{current?.view}</div>;
}
